<template>
    <div>

        <div>

            <div class="form-row mb-3">
                <div class="col col-12 col-md-3">
                    <az-input 
                        placeholder="Selecione o Plano..."
                        icon="fa-regular fa-rectangle-list" 
                        type="select"
                        service="contabil_planos.index"
                        optionsData="id_contabil_plano"
                        optionsMode="aql"
                        v-model="id_contabil_plano" 
                        @input="load()" />
                </div>

                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb v-if="id_contabil_plano">
                            <importacao service="contabil_contas" :parms="{ id_contabil_plano: id_contabil_plano }" @refresh="load()" />
                            <div class="input-group-append">
                                <button type="button" class="btn btn-outline-primary" @click="incluir ()">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="id_contabil_plano ? 'Nenhuma conta identificada.' : 'Selecione o Plano Contábil.'" 
                icon="fas fa-search" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in dado.js_classes" :key="icx" class="ml-1">
                                <span class="badge badge-success">
                                    {{ classe }}
                                </span>
                            </a>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_contabil_plano ? '' : 'Novo' }}
                            Plano
                            {{ item && item.id_contabil_plano ? '#' + item.id_contabil_plano : '' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Código"
                                    :validate="validate"
                                    required
                                    v-model="item.st_codigo" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Código Externo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_id_externo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    type="textarea"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="contabilConta" :id="item.id_contabil_conta" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_contabil_conta ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Multiselect from 'vue-multiselect';
import Importacao from '../../cadastros/shared/Importacao.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            id_contabil_plano: "", 
            options_classes: [], 
        }
    },

    props: ['cadastro'],

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        Multiselect,
        Importacao, 
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        filtrar(texto) { 
            if ( !texto ) { 
                this.search = "";
                return;
            }

            const pesq = '"' + texto + '"';

            this.search = ( pesq == this.search ) ? "" : pesq; 
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },
        
        incluir () { 
            this.validate = false;

            if ( !this.id_contabil_plano ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção', 
                    detail: 'Selecione o Plano Contábil.', 
                    life: 3000 
                });
                return;
            }

            let item = {
                id_contabil_plano: this.id_contabil_plano, 
                st_codigo: "",
                st_titulo: "",
                st_id_externo: "", 
                fl_ativo: true, 
                st_observacoes: "",
                st_tipo: "", 
                js_classes: [], 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'contabil_contas',
                func: 'index',
                parms: { 
                    cadastro: true, 
                    id_contabil_plano: this.id_contabil_plano, 
                },
            });
        },
        editar (item) { 
            if ( !item.js_classes ) 
                item.js_classes = [];

            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'contabil_contas',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'contabil_contas',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.$util.loadItem(this, {
            service: 'contabil_contas',
            func: 'tags',
        })
        .then(res => {
            this.options_classes = res;
        });

        this.breadcrumb = [
                { name: "Contabilidade", path: "/contabilidade/planos"},
                { name: "Contas" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>